/* global AppSettings */
/**
 * Checks the admin level of place, to pass correct maximal distance till
 * stores which need to be rendered and max results of stores to be shown
 * Applicable only to Google maps.
 *
 * @param   {Object}   Google maps Place object
 * @returns {Object}   maxDistance, (optional) maxResults, country
 */

  // https://developers.google.com/maps/documentation/geocoding/#Types
  const maxDistance = AppSettings.mapsMaxDistanceToStore
    ? AppSettings.mapsMaxDistanceToStore
    : false;
  const SearchParameters = [
    // Address
    {
      parameters: { maxDistance: maxDistance ? maxDistance.address : 25000, maxResults: 10 },
      types: [
        'establishment',
        'street_address',
        'point_of_interest',
        'route',
        'subpremise',
        'intersection',
        'premise',
        'bus_station',
        'train_station',
        'transit_station',
        'street_number',
      ],
    },

    // City
    {
      parameters: { maxDistance: maxDistance ? maxDistance.city : 25000, maxResults: 50 },
      types: [
        'administrative_area_level_3',
        'administrative_area_level_4',
        'administrative_area_level_5',
        'colloquial_area',
        'locality',
        'ward',
        'sublocality',
        'neighborhood',
        'postal_code',
        'airport',
        'park',
      ],
    },

    // State
    {
      parameters: { maxDistance: maxDistance ? maxDistance.state : 500000, maxResults: 100 },
      types: ['administrative_area_level_1', 'administrative_area_level_2'],
    },

    // Country
    {
      parameters: { country: AppSettings.country },
      types: ['country'],
    },
  ];

  function getLowestAdminLevel(place) {
    let searchParameters;
    if (place.types && place.types.length) {
      // Find lowest search parameters that have a type that matches
      SearchParameters.forEach(function (parameter) {
        if (!searchParameters) {
          parameter.types.forEach(function (type) {
            if (!searchParameters) {
              if (place.types.indexOf(type) !== -1) {
                searchParameters = parameter.parameters;
              }
            }
          });
        }
      });

      return searchParameters;
    }
  }

  export default function getMapAdminLevel(place) {
    if (place) {
      return getLowestAdminLevel(place);
    }
  };

